import {omit} from 'lodash';

import {TeamModel} from '../../../models/api/teamModel';
import {AppAction} from '../../appActions';
import {ResourceMap} from '../../appTypes';
import {TeamPreferencesActionsEnum} from '../teamPreferences/teamPreferencesActions';
import {teamPreferencesReducer} from '../teamPreferences/teamPreferencesReducer';
import {TeamsActionsEnum} from './teamsActions';

export function teamsReducer(state: ResourceMap<TeamModel>, action: AppAction): ResourceMap<TeamModel> {
  switch (action.type) {
    // Single team update.
    case TeamsActionsEnum.TEAM_UPDATED:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };

    // Single team deletion.
    case TeamsActionsEnum.TEAM_DELETED:
      return omit(state, action.payload);

    // Team business hours preferences
    case TeamPreferencesActionsEnum.TEAM_BUSINESS_HOURS_PREFERENCES_UPDATED:
    case TeamPreferencesActionsEnum.TEAM_BUSINESS_HOURS_PREFERENCES_RESET_ERROR:
    case TeamPreferencesActionsEnum.TEAM_BUSINESS_HOURS_PREFERENCES_UPDATE_FAILED: {
      const currentTeam = state[action.payload.teamId];
      if (!currentTeam) {
        return state;
      }

      return {
        ...state,
        [action.payload.teamId]: {
          ...currentTeam,
          preferences: teamPreferencesReducer(currentTeam.preferences, action),
        },
      };
    }

    default:
      return state;
  }
}
